import { DatasourceType } from '@/shared/types/collections';

export const DOCUMENT_TYPES_WITH_PREVIEW = ['pdf', 'docx', 'txt', 'md'];

export const DATASOURCE_TYPES_BY_TAB = {
  faq: [DatasourceType.FAQ],
  documents: [DatasourceType.FILES],
  webpages: [DatasourceType.WEBSITE],
  external: [
    DatasourceType.ZENDESK_KB,
    DatasourceType.INTERCOM_KB,
    DatasourceType.WORKVIVO_KB,
    DatasourceType.GDRIVE,
  ],
} as const;

export const DATASOURCE_TYPE_TO_TAB = {
  [DatasourceType.FAQ]: 'faq',
  [DatasourceType.FILES]: 'documents',
  [DatasourceType.WEBSITE]: 'webpages',
  [DatasourceType.ZENDESK_KB]: 'external',
  [DatasourceType.INTERCOM_KB]: 'external',
  [DatasourceType.WORKVIVO_KB]: 'external',
  [DatasourceType.GDRIVE]: 'external',
} as const;

export const ROOT_DATASOURCE_NAMES = {
  faq: 'root-faq',
  documents: 'root-documents',
  webpages: 'root-webpages',
  external: 'root-external',
} as const;

export const ROOT_DATASOURCE_TYPES = {
  [DatasourceType.FAQ]: { type: DatasourceType.FAQ, name: ROOT_DATASOURCE_NAMES.faq, config: {} },
  [DatasourceType.FILES]: {
    type: DatasourceType.FILES,
    name: ROOT_DATASOURCE_NAMES.documents,
    config: {},
  },
} as const;

export const MAX_TXT_PREVIEW_LENGTH = 150;
